import React,{useState,useEffect} from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {getListBundleProductV2} from '../../../service/productDetailService'
import {responsiveproductlistmobile}  from "../../../utils/constant";
import {FromatNumberVIE} from '../../../utils/format';
import { ItemDefault} from "../../../components/mobile/product";
import { navigate } from 'gatsby';
import "./bundleproduct.css"

const BundleProductMobile = ({sku})=>{
    var [dataItemsBundle, setdataItemsBundle] = useState([]);
      useEffect(()=>{
        let user_id = '';
        if(window.localStorage.getItem('_id')){
          user_id= window.localStorage.getItem('_id');
        }
        try {
            getListBundleProductV2(sku,user_id).then((response) => {
                if(response !== undefined){
                    if(response.status === 200){
                        setdataItemsBundle(response['message']);
                    }
                }
                
          });     
        } catch(err) {
            setdataItemsBundle([]);
          console.error(err);
        }   
      },[]);
      const handleRedirect=(uri)=>{
        window.location.href = '/mobile'+uri;
      }
    if(dataItemsBundle?.length>0){
    return(
        <div className="row mgt-10 pdt-10 bg-white">
                <div className="row mgx-0">
                    <div className="col-8 infor-product-title">
                        <span>Gợi ý mua cùng</span>
                    </div>
                    <div className="col-4 header-right color-red-i" onClick={()=>handleRedirect('/goi-y-mua-cung.html?'+sku)}>
                        <span>Xem tất cả</span>
                        <i className="fa fa-angle-right fa-1"></i>
                        <i className="fa fa-angle-right fa-1"></i>
                    </div>
                </div>    
                <div className="col-12 product-similar mgt-10 pdx-0">
                <div className="row mgx-0">
                    <Carousel key="product-bundle-mobile"
                     responsive={responsiveproductlistmobile}
                     fade={true}
                    >
                        { 
                            dataItemsBundle.map((item, index)=>{
                                return <ItemDefault key={index} item={item} index={index}/>
                            })
                        } 
                    </Carousel>
                    </div>
                </div>
            </div>  
    )
}else{
    return null;
}
}


export default BundleProductMobile